/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Decimal as IDecimal, ICustomDate } from "@Internal/Contracts";
import BaseModel from "../Model";
import { Recurrence } from "../Misc";

export default interface BaseInvoice extends BaseModel {
    /* In this case, we're not mapping invoices, therefore we added the `ExernalId` property to
    receive the id returned by stripe directly. */
    ExternalId?: string;
    DownloadURL?: string;
    Name?: string;
    Status?: "Draft" | "Open" | "Paid" | "Uncollectible" | "Void" | "Rejected";
    Total?: IDecimal;
    CreatedAt?: ICustomDate;
    /* Human-facing Stripe invoice number (e.g. FASTR-0001). */
    Number?: string;
    /* Invoice due date (subscription invoices may have none). */
    DueDate?: ICustomDate;
    /* Internal customer id resolved from the invoice mirror, when known. Lets the Facturation list
       open the related customer on row click; absent when the Stripe customer was never mapped. */
    Customer?: number;
    /* Billing customer carried directly on the Stripe invoice. */
    CustomerName?: string;
    CustomerEmail?: string;
    /* Billing frequency derived from the invoice line recurrence. */
    Frequency?: Recurrence;
}
